


























import { FetchAllProceduresByUserCommand } from '@/Application/Procedures/FetchAllProceduresByUserCommand'
import { UserProcedureDto } from '@/Application/Procedures'
import { PaginatedResultDto } from '@/Application/Pagination/PaginatedResultDto'
import {
  FetchAllProceduresByUserCommandHandlerProvider
} from '@/Infrastructure/Procedures/Provider/FetchAllProceduresByUserCommandHandlerProvider'
import BidProcedureRow from '@/UI/UserProcedures/BidProcedures/BidProcedureRow.vue'
import BidProceduresTableHeader from '@/UI/UserProcedures/BidProcedures/BidProceduresTableHeader.vue'
import BidProceduresListSearch from '@/UI/UserProcedures/BidProcedures/BidProceduresListSearch.vue'
import { EventBus } from '@/Infrastructure/EventBus/EventBus'
import Paginator from '@/UI/Shared/Paginator/Paginator.vue'
import { ProcedureFilters } from '@/Domain/Procedures/RepositoryModifiers/ProcedureFilters'
import { AccountId } from '@/Domain/Account/AccountId'
import { namespace } from 'vuex-class'
import { Vue, Component } from 'vue-property-decorator'

const accountStore = namespace('account')

@Component({
  components: {
    Paginator,
    BidProceduresListSearch,
    BidProcedureRow,
    BidProceduresTableHeader
  }
})
export default class BidProceduresList extends Vue {
  @accountStore.Getter
  public accountId!: string

  public proceduresList: UserProcedureDto[] = []
  public currentPage = 1
  public totalPages = 1
  public itemsPerPage = 10
  public totalProcedures = 0
  public filters = {
    code: '',
    procedureType: '',
    province: '',
    estado: '',
    dateFrom: ''
  }

  mounted (): void {
    this.loadProcedures()
  }

  loadProcedures (): void {
    EventBus.$emit('loading', true)
    const accountId = new AccountId(this.accountId)
    const command = new FetchAllProceduresByUserCommand(
      accountId,
      { page: this.currentPage, itemsPerPage: this.itemsPerPage },
      this.filters
    )
    const provider = new FetchAllProceduresByUserCommandHandlerProvider()
    const handler = provider.provide()
    handler.handle(command)
      .then((response: PaginatedResultDto<UserProcedureDto>) => {
        this.proceduresList = response.items
        this.currentPage = response.currentPage
        this.totalPages = response.totalPages
        this.totalProcedures = response.totalItemCount
      })
      .finally(() => {
        EventBus.$emit('loading', false)
      })
  }

  onPageChanged (newPage: number): void {
    this.currentPage = newPage
    this.loadProcedures()
  }

  onFiltersUpdated ($event: ProcedureFilters): void {
    const lastFilters = { ...this.filters }
    this.filters.code = $event.code || ''
    this.filters.procedureType = $event.procedureType || ''
    this.filters.province = ($event.province !== '0' ? $event.province : '') || ''
    this.filters.dateFrom = $event.dateFrom || ''
    this.filters.estado = ''
    if (JSON.stringify(this.filters) !== JSON.stringify(lastFilters)) {
      this.proceduresList = []
      this.currentPage = 1
      this.loadProcedures()
    }
  }
}
